import { alertConstants } from '../_constants';

const initalState = {
  alerts: [] 
};

export function alert(state = initalState, action) {

  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        ...state,
        alerts: [
            ...state.alerts,
            {
                key: action.key,
                variant: 'success',
                message: action.message
            },
        ]
      };
    case alertConstants.ERROR:
      return {
        ...state,
        alerts: [
            ...state.alerts,
            {
                key: action.key,
                variant: 'error',
                message: action.message
            },
        ]
      };
      break;
    case alertConstants.CLEAR:
      return {
        ...state,
        alerts: state.alerts.filter(
          alert => alert.key !== action.key,
        ),
      };
    default:
      return state;
  }
}